import React from 'react';
import moment from 'moment-timezone';
import { ApiMixin } from 'mixins';
import EventCard from 'components/eventCard';

export default React.createClass({
    mixins: [ApiMixin],

    contextTypes: {
        router: React.PropTypes.object,
    },

    getInitialState() {
        return {
            loading: false,
            events: [],
        };
    },

    componentDidMount() {
        this.setState({ loading: true });

        this.api.request('/api/events', {
            method: 'GET',
            success: (data) => {
                this.setState({
                    loading: false,
                    events: data.map(event => {
                        event.date = moment(event.date);
                        return event;
                    }),
                });
            },
        });
    },

    render() {
        return (
            <div className="page-container">
                <div className="page-header">
                    <h2>My Events</h2>
                </div>

                <div className="my-events">
                    <div className="event-list">
                        {this.state.events.map((event) => {
                            return <EventCard key={event.id} event={event} />;
                        })}
                    </div>
                </div>
            </div>
        );
    },
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/events.jsx